import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/delta2/h5/');

export default function OtherProduct({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const otherlag = ['jp', 'de', 'fr', 'cn', 'kr'];
    const { locale } = useRouter();
    const lg = otherlag.includes(locale) ? locale : 'us';

    const solarImgMap: Record<string, string> = {
        us: 'solar',
        kr: 'solar_kr',
    };
    const solarImg = solarImgMap[locale] || solarImgMap.us;

    return (
        <div
            className={`${css.otherProduct} otherProduct GtmModuleData-section`}
            data-section-id={css.otherProduct}
            data-section-title={t('delta2.aniB_box1_msg1')}
        >
            <div className={lg !== 'us' ? 'jp-fill' : ''}>
                <div className="section-top">
                    <div className="left">
                        <div className="other-p-1">
                            <EFPic name={['1-3kWh.webp', '1-3kWh.jpg']} loading="eager" />
                        </div>
                        <div className="text">
                            <div className="title">{t('delta2.aniB_box1_msg1')}</div>
                            <div className="desc">{t('delta2.aniB_box1_msg2')}</div>
                        </div>
                    </div>
                    <div className="right">
                        <div className="top">
                            <div className="other-p-2">
                                <EFPic name={['other_p_2.webp', 'other_p_2.jpg']} loading="eager" />
                            </div>
                            <div className="text">
                                <div className="title">
                                    {locale === 'kr' ? (
                                        <>
                                            <span className="number2">90%</span>
                                            <span className="text2">{t('delta2.aniB_box3_msg1')}</span>
                                        </>
                                    ) : (
                                        t('delta2.aniB_box3_msg1')
                                    )}
                                </div>
                                <div className="rate">{t('delta2.aniB_box3_msg2')}</div>
                                <div className="desc">{t('delta2.aniB_box3_msg3')}</div>
                            </div>
                        </div>
                        <div className="bottom">
                            <div className="other-p-3">
                                <EFPic name={['appcontrols.webp', 'appcontrols.jpg']} loading="eager" />
                            </div>
                            <div className="text">{t('delta2.aniB_box6_msg1')}</div>
                        </div>
                    </div>
                </div>
                <div className="section-middle">
                    <div className="left">
                        <div className="other-p-4">
                            <EFPic name={[`${solarImg}.webp`, `${solarImg}.jpg`]} loading="eager" />
                        </div>
                        <div className="text">{t('delta2.aniB_box5_msg1')}</div>
                    </div>
                    <div className="right">
                        <div className="other-p-5">
                            <EFPic name={[`${locale === 'tw' ? 'cn' : lg}.webp`, `${locale === 'tw' ? 'cn' : lg}.jpg`]} loading="eager" />
                        </div>
                    </div>
                </div>
                <div className="section-bottom">
                    {locale === 'au' && (
                        <div className="left">
                            <div className="top">
                                <div className="other-p-8">
                                    <EFPic name={['charging.webp', 'charging.jpg']} loading="eager" />
                                </div>
                                <div className="text text-8">
                                    <div className="text1">{t('delta2.aniB_box4_msg1')}</div>
                                    <div className="text2">{t('delta2.aniB_box4_msg2')}</div>
                                </div>
                            </div>
                            <div className="bottom">
                                <div className="other-p-9">
                                    <EFPic name={['other-p-9.webp', 'other-p-9.png']} loading="eager" />
                                </div>
                                <div className="text-9">
                                    <div className="text1">{t('delta2.aniB_box5_msg2')}</div>
                                </div>
                            </div>
                        </div>
                    )}
                    {locale !== 'au' && (
                        <div className="left">
                            <div className="other-p-6">
                                <EFPic name={['charging.webp', 'charging.jpg']} loading="eager" />
                            </div>
                            <div className="text">
                                <div className="text1">{t('delta2.aniB_box4_msg1')}</div>
                                <div className="text2">{t('delta2.aniB_box4_msg2')}</div>
                            </div>
                        </div>
                    )}
                    <div className="right">
                        <div className="other-p-7">
                            <EFPic name={['other_p_7.webp', 'other_p_7.jpg']} loading="eager" />
                        </div>
                        <div className="text">
                            {(lg === 'us' || lg === 'cn') && <div className="text1">{t('delta2.aniB_box2_msg1')}</div>}

                            <div className="text2">
                                {t('delta2.aniB_box2_msg2')} {['cn', 'tw'].includes(locale) ? <br></br> : ''} {t('delta2.aniB_box2_msg3')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
